import * as React from 'react';
import { DragSource, DragSourceConnector, DragSourceMonitor } from 'react-dnd';

import { placeholderTypes } from '../../../../../infrastructure/placeholderTypes';
import { toggleDragginClass } from '../../../../../lib/helpers';

const boxSource = {
  beginDrag(props: any) {
    return {
      type: placeholderTypes.BlankPage,
    };
  },
};

export interface IBlankPageProps {
  connectDragSource?(element: JSX.Element): JSX.Element;
  type: string;
  isDragging?: boolean;
  title: string;
}
class BlankPage extends React.Component<IBlankPageProps> {

  render() {
    const isDragging = (this.props.isDragging) ? this.props.isDragging : false;
    const className = `divider-box-title BlankPage-item ${this.props.isDragging ? "active" : ""}`;
    toggleDragginClass(isDragging);
    return this.props.connectDragSource!(
      <span className={className}>{this.props.title}</span>,
    );
  }
}

function collectDrag(connect: DragSourceConnector, monitor: DragSourceMonitor) {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging(),
  };
}

export default (
  DragSource(props => props.type, boxSource, collectDrag)
)(BlankPage);



// WEBPACK FOOTER //
// ./src/components/Editor/components/SidePanel/ObjectTab/BlankPage.tsx